import React, { FC, useCallback, useRef, useState } from 'react';
import { GrayButton } from '@shared/uikit/button';
import { IApplicationAttachment } from '@entities/application/IApplicationTask';
import { toast } from 'react-toastify';
import { useUploadApplicationImage } from '@app/queries/application/board/useUploadApplicationImage';
import { getBase64 } from '@app/utils/baseEncoder';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';

interface IProps {
  attachments?: {}[];
}

const InputFiles: FC<IProps> = ({ attachments: defaultAttachments = [] }) => {
  const fileInput = useRef<HTMLInputElement>(null);
  const uploadApplicationImageFetcher = useUploadApplicationImage();
  const [attachments, setAttachments] = useState<IApplicationAttachment[]>(defaultAttachments);

  const onClickUpload = useCallback(() => {
    fileInput?.current?.click();
  }, []);

  const onUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target?.files) return;
    const uploadedFile = e.target?.files[0];

    (async () => {
      try {
        const data = await getBase64(uploadedFile);
        const file = await uploadApplicationImageFetcher.fetchData({
          fileData: '' + data,
          filename: uploadedFile.name,
        });
        setAttachments([...attachments, file]);

        toast.success('Загрузка файла выполнена успешно.');
      } catch (e: any) {
        if (e.status === ERR_BAD_REQUEST) {
          toast.error(e.response.data.error);
        } else {
          toast.error('Ошибка при загрузке файла.');
        }
      }
    })();
  };

  const getFileType = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toUpperCase();
    return ext || 'FILE';
  };

  const isImage = (file: any) => {
    return file.mime_type.startsWith('image/');
  };

  return (
    <div className="flex flex-col cursor-pointer">
      <input
        type="file"
        accept="image/*,.pdf,.doc,.docx,.txt,.xls,.xlsx"
        className="hidden"
        ref={fileInput}
        onChange={onUpload}
        multiple
      />
      <div className="w-[160px] mb-[15px]">
        <GrayButton
          onClick={() => onClickUpload()}
          title={
            <div className="flex items-center gap-2 justify-start cursor-pointer">
              <div className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.67812 9.09891L9.66894 4.08096C10.8352 2.37211 8.5839 0.0665968 6.73955 1.39569L1.64023 6.57638C-0.556882 9.8855 3.07773 15.2289 7.58039 12.0012L13.3578 6.08814"
                    stroke="white"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div className="inline-block gap-[5px] items-center fill-[white] text-[white] text-[12px]">
                Прикрепить файлы
              </div>
            </div>
          }
        />
      </div>
      {attachments?.length ? (
        <div className="flex flex-wrap gap-4">
          {attachments.map((item: IApplicationAttachment) => (
            <div>
              {isImage(item) ? (
                <div
                  style={{
                    backgroundImage: `url(${item?.file_url})`,
                  }}
                  className={`flex rounded-[16px] pb-[5px] w-[127px] h-[120px] border solid border-[#373539] bg-cover`}
                  onClick={() => window.open(item?.file_url)}
                ></div>
              ) : (
                <div className="flex justify-center items-center rounded-[16px] pb-[5px] w-[127px] h-[120px] bg-[#211F24]">
                  <span className="text-[24px] text-[#373539] font-semibold">
                    {getFileType(item?.filename)}
                  </span>
                </div>
              )}
              <p className="mt-[10px] text-[12px] truncate w-[130px] text-center">
                {item?.filename}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-wrap gap-4">
          <div className="flex rounded-[16px] pb-[5px] w-[127px] h-[120px] border solid border-[#373539]"></div>
        </div>
      )}
    </div>
  );
};

export default InputFiles;
